import axios from "axios";
import qs from "qs";
import icomplyLogo from "../../../../../assets/images/icomply.png";
import authServices from "../../../../../services/authServices";
import dataProvider from "../../../../../services/dataProvider";

export default async function Bucket2PDFTemplate(formState) {
    let link = await onFileView(formState[formState.formType + "File"]);

    let html = `
        <div class="template-container">
            <style>
                .template-container {
                    background-color: #fff ;
                    margin : 1rem ;
                    padding: 1rem ;
                    font-family: sans-serif ;
                    border-radius: 8px ;
                    border : 1px solid #eee ;
                }

                .template-icomply-brand {
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    padding: 2rem 0;
                }

                .template-icomply-brand img {
                    height : 3rem ;
                }

                .template-self-declaration {
                    background-color: #fff ;
                    padding: 1rem ;
                    font-family: sans-serif ;
                    border-radius: 8px ;
                    border : 1px solid #eee ;
                    margin-top:1.5rem;
                }

                .template-self-declaration h3{
                    line-height:1;
                }

                .template-self-declaration p {
                    font-size : 14px ;
                }
                
                .template-container .template-name {
                    font-size: 1.25rem ;
                    font-weight: 700 ;
                    line-height:2;
                }
                
                .template-container .template-field {
                    flex: 1 ;
                    display: flex ;
                    line-height: 2.5rem ;
                }

                .template-container .template-link {
                    text-align:left;
                }

                .template-tnc {
                    display: flex ;
                    align-items:center;
                }
                
                .template-container .template-field .template-key ,
                .template-container .template-link .template-key {
                    font-weight: 700 ;
                    margin-right: 0.5rem ;
                }
                
                .template-container .template-field .template-value ,
                .template-container .template-link .template-value {
                    color: #444;
                }
            </style>

            <div class="template-icomply-brand">
                <img src="${icomplyLogo}" />
            </div>

            <div class="template-name">${formState.formTitle}</div>

            <div class="template-field">
                <div class="template-key">Uploaded File</div>
                <div class="template-value">
                    <a href="${link}">View File</a>
                </div>
            </div>

            <div class="template-self-declaration">
                <h3>Self Declaration</h3>
                <p>
                    You are about to declare that you have met requirements under the Property & Stock Agents Act 2002. This declaration will be used to demonstrate compliance and may be subject to audit review by Fair Trading
                </p>
                <div class="template-tnc">
                    <input type="checkbox" checked="${formState.tncAgreed}" />
                    <span style="margin-left:0.25rem"> I agree to the Terms of Service</span>
                </div>
                <div class="template-field">
                    <div class="template-key">Name Of Person Completing Form</div>
                    <div class="template-value">${formState.nameOfPersonCompletingForm}</div>
                </div>
                <div class="template-field">
                    <div class="template-key">Date</div>
                    <div class="template-value">${formState.dateOfFormCompletionInString}</div>
                </div>
            </div>
        </div>
    `;

    return html;
}

async function onFileView(fileName) {
    var data = qs.stringify({
        filePath: fileName,
    });

    var config = {
        method: "post",
        url: dataProvider.baseUrl + "getFileUrlFromFilePath",
        headers: {
            token: authServices.getToken(),
        },
        data: data,
    };

    return new Promise((res) => {
        axios(config)
            .then(function (response) {
                res(response?.data?.data[0] || "");
            })
            .catch(function (error) {
                res("");
            });
    });
}
